import { useCallback, useEffect, useState } from 'react';

/**
 * Nawigacja oparta o hash adresu (#/containers).
 *
 * Poprzednia wersja trzymała aktywny widok w useState wewnątrz Dashboardu, przez
 * co przycisk "wstecz" przeglądarki wychodził z aplikacji zamiast wrócić do
 * poprzedniego ekranu, a widoku nie dało się dodać do zakładek ani wysłać linkiem.
 *
 * Hash zamiast pełnego routingu, bo aplikacja jest hostowana jako statyczny
 * build — ścieżki typu /containers wymagałyby konfiguracji przekierowań po
 * stronie serwera, a hash działa wszędzie i nie dokłada zależności.
 */
export function useHashRoute(defaultRoute) {
  const read = useCallback(
    () => window.location.hash.replace(/^#\/?/, '') || defaultRoute,
    [defaultRoute]
  );

  const [route, setRoute] = useState(read);

  useEffect(() => {
    const onHashChange = () => setRoute(read());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, [read]);

  const navigate = useCallback((next) => {
    window.location.hash = `/${next}`;
  }, []);

  return [route, navigate];
}

export default useHashRoute;
